<template>
  <div class="contenedor">
    <div class="row">
      <div class="col-12">
        <Fieldset title="Cold Call Rules" :mykey="901">
          <div v-if="loading" class="bg-light p-3">
            <p class="mb-0">{{ $t("lang.elevenlab.loading") || "Loading..." }}</p>
          </div>

          <div v-else-if="rulesList.length === 0" class="bg-light p-3">
            <p class="mb-0">No cold call rules found.</p>
          </div>

          <div v-else>
            <div
              v-for="rule in rulesList"
              :key="rule.id"
              class="bg-light p-3 mb-3"
            >
              <label class="font-weight-bold">
                {{ rule.name }}
                <i
                  v-if="editnow != rule.id"
                  class="icon-pencil text-primary ml-1 cursor-pointer"
                  @click="editnow = rule.id"
                ></i>
                <i
                  v-if="editnow == rule.id"
                  class="icon-close text-danger ml-1 cursor-pointer"
                  @click="editnow = false"
                ></i>
              </label>

              <div v-if="editnow != rule.id">
                <p class="mb-0 text-muted" style="white-space: pre-wrap;">
                  {{ rule.data || "—" }}
                </p>
              </div>

              <div v-else>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="rule.data"
                  rows="6"
                ></textarea>
                <button
                  class="mt-2 btn btn-sm btn-primary"
                  @click="saveRule(rule)"
                >
                  {{ $t("lang.button.save") }}
                </button>
              </div>
            </div>
          </div>
        </Fieldset>
      </div>
    </div>
  </div>
</template>
<script>
import { adminService } from "@/_services";
import Fieldset from "@/components/Common/Fieldset.vue";

export default {
  components: {
    Fieldset,
  },

  data() {
    return {
      loading: false,
      oliverwords: null,
      rulesList: [],
      editnow: "",
    };
  },

  created() {
    this.getOliverSettings();
  },

  methods: {
    getOliverSettings() {
      this.loading = true;
      adminService
        .getOliverSettings({ wordListComplete: true })
        .then((response) => {
          this.oliverwords = response;
          this.rulesList = this.buildRulesList(response.cold_call_rules);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    buildRulesList(coldCallRules) {
      if (!coldCallRules || typeof coldCallRules !== "object") {
        return [];
      }
      return Object.keys(coldCallRules).map((key) => {
        const item = coldCallRules[key] || {};
        return {
          id: item.id,
          name: item.name, // (item.name == 'main_cold_call_rules') ? 'Item cold rules' : (item.name || key),
          data: item.data == null ? "" : String(item.data),
          status: item.status,
          api_key: item.api_key,
        };
      });
    },

    saveRule(rule) {      
      adminService
        .updateOliverVariables(rule.data, rule.name)
        .then(() => {
          this.editnow = false;
          this.getOliverSettings();
        });
    },
  },
};
</script>
